import get from 'lodash/get';
import isNil from 'lodash/isNil';
import React from 'react';
import {INPUT_TYPES} from '../enums/InputTypes';
import {OPTIONS_TYPES_DEFINITION} from '../enums/OptionsTypes';


const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);

export function getFieldTypeLabel(cardType) {
  switch (cardType) {
    case INPUT_TYPES.reference_link:
      return 'Link';
    case INPUT_TYPES.text_long:
      return 'Paragraph';
    case INPUT_TYPES.text_short:
      return 'Text';
    case INPUT_TYPES.scale:
      return 'Range';
    default:
      return capitalizeFirstLetter(cardType);
  }
}

export function simpleObjHash(obj) {
  const base = JSON.stringify(obj);
  let hash = 0;
  if (base.length === 0) return hash;
  [...base].forEach(x => {
    const char = x.charCodeAt(0);
    hash = (hash << 5) - hash + char;
    hash &= hash; // Convert to 32bit integer
  });
  return hash;
}

export function renderComponentIfDefined(Components, type, props) {
  const Component = Components[type];
  if (!Component) {
    console.warn(`Component for '${type}' type is not defined`);
    return null;
  }
  return <Component {...props} />;
}

export function setCaretPosition(elem, caretPos) {
  if (!isNil(elem)) {
    if (typeof caretPos === 'undefined') return elem.focus();
    if (elem.createTextRange) {
      const range = elem.createTextRange();
      range.move('character', caretPos);
      range.select();
    } else if (elem.selectionStart) {
      elem.focus();
      elem.setSelectionRange(caretPos, caretPos);
    } else elem.focus();
  }
}

/**
 *
 * @param {string} typeName
 */
export function getOptionsForType(typeName) {
  const type = OPTIONS_TYPES_DEFINITION[typeName];
  if (!type) {
    throw Error(`wrong input type: ${typeName}`);
  }

  const options = {};
  Object.keys(type.properties).forEach(key => {
    options[key] = {
      ...type.properties[key],
      value: type.properties[key].default,
    };
  });

  return options;
}

export function getFormAsString(form) {
  return get(form, 'title');
}



// WEBPACK FOOTER //
// ./src/js/forms/utils/index.js